module.exports = __webpack_public_path__ + "img/default-img-gift.0790ec3a.png";